export default "__VITE_ASSET__kCMwJzad__"